// 邀請相關翻譯

export const invites = {
    invitationCode: 'Invitation Code',
    enterInvitationCode: 'Enter invitation code',
    copied: 'Copied!',
    copyInvitationLink: 'Copy Invitation Link',
    inviteRewardDescription: 'Invite 1 friend to register Catoo, reward {amount} Credits, more extra credits for your friends purchases.',
    invitationRewardBalance: 'Reward Credits',
    totalInvitationCount: 'Total Invitation Count',
    monthlyReferrals: 'Monthly Invitation Count',
    totalPaidCount: 'Total Paid Count',
    totalAwardAmount: 'Total Award Amount',
    registrationReward: 'Registration Reward',
    invitationReward: 'Friend Purchase Reward',
    invitationRecords: 'Invitation Records',
    invitationTime: 'Invitation Time',
    invitedUser: 'Invited User',
    email: 'Email',
    status: 'Status',
    rewardAmount: 'Reward Amount',
    rewardCredits: 'Reward Credits',
    unknownUser: 'Unknown User',
    completed: 'Completed',
    pending: 'Pending',
    noInvitationRecords: 'No invitation records'
  };
